type SelectedOverlayProps = {
  visible: boolean;
};

export const SelectedOverlay = ({ visible }: SelectedOverlayProps) => {
  if (!visible) return null;
  return (
    <div className="vai-absolute vai-inset-0 vai-bg-primary/20 vai-flex vai-items-center vai-justify-center">
      <span className="vai-bg-white vai-rounded-full vai-px-2 vai-text-xs">
        Selected
      </span>
    </div>
  );
};
